/**
 * @fileoverview Host matter-scoped portal-result inspection through `kc-internal-frontend/src/components/Inbox/PortalResult.js`. The parent supplies selected review/client context and owns dismissal. The shared result surface retains its backend permission/version boundary across matter and Inbox entry points.
 */

import React, { useEffect, useRef } from 'react';
import { AppModal } from '../shared';
import PortalResult from '../Inbox/PortalResult';



export default function PaymentResultModal({ visible, onClose, reviewId, matterNumber, clientId }) {
  const content = useRef(null);
  useEffect(

  () => {
    if (!visible) return undefined;
    const dialog = content.current?.closest('[role="dialog"]');
    content.current?.focus();
    

    function trap(event) {
      if (event.key !== 'Tab' || !dialog) return;
      const controls = [...dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), select:not([disabled]), a[href]')];
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === content.current)) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first?.focus();
      }
    }
    dialog?.addEventListener('keydown', trap);
    return () => dialog?.removeEventListener('keydown', trap);
  }, [visible, reviewId, matterNumber, clientId]);
  return <AppModal visible={visible} title="Verification and banking results" onClose={onClose} width={760}>
    <div ref={content} tabIndex={-1}>
      {visible ? <PortalResult key={`${matterNumber}:${clientId}:${reviewId}`} reviewId={reviewId} matterNumber={matterNumber} clientId={clientId} embedded /> : null}
    </div>
  </AppModal>;
}
